<a href="javascript:void(0)" *ngIf="product" class="featured-product-items" [ngClass]="cardClass">
    <div class="secondary-actions">
        <ng-container *ngTemplateOutlet="secondaryActionsTemplate"></ng-container>
    </div>
    <div class="product-card-wrapper">
        <a [routerLink]="[PRODUCT_ROUTE, product.usanaId]" class="primary-info">
            <product-image imageClass="img-fluid"
                           imageAutomationTag="productImageFeatured"
                           [images]="product.productImages"
                           imageType="productImage"
                           imageSize="SM"
                           [imageOrder]="0"></product-image>
            <div class="product-details-container">
                <h2 [innerHTML]="product.productDescription?.name" class="featured-product-name"
                    automation-tag="featuredProductName"></h2>
                <fs-not-eligible class="text-start" [product]="product"></fs-not-eligible>
                <div class="featured-details">
                    <div *ngIf="showPricing" class="featured-current-price"
                         automation-tag="featuredCurrentPrice">
                        {{ priceDisplay }}
                    </div>
                    <div
                        *ngIf="showPricing && showRetailStrikethroughByProduct(product) && product.retailPrice && !hideStrikeThroughPricing"
                        class="featured-retail-price featured-content" automation-tag="featuredRetailPrice">
                        <span translate="cart.product.retail.price"></span> {{product.retailPrice.price | usanacurrency | async}}
                    </div>
                    <div *ngIf="showPcComparisonByProduct(product) && product.pcPrice && !hidePreferredPricing"
                         class="featured-content" automation-tag="featuredPcPrice">
                        <span translate="cart.product.pc.price"></span> {{product.pcPrice.price | usanacurrency | async}}
                    </div>
                    <div *ngIf="shouldDisplayVolume && productVolume" class="featured-content">
                        <span translate="cart.product.recommended.volume"></span> {{productVolume}}
                    </div>
                </div>
            </div>
        </a>
        <div class="primary-actions" *ngIf="showCart || canEditAutoOrderOnline">
            <ng-container *ngTemplateOutlet="primaryActionsTemplate"></ng-container>
        </div>
        <div *ngIf="shareOptions">
            <copy-short-url
                class="share-list-url"
                [buttonClass]="'button button-primary social-share'"
                [shareOptions]="shareOptions"
                [hideTextMobile]="false"
                [showIcon]="false"></copy-short-url>
        </div>
    </div>
</a>
